
import { texto } from '@/shared/utils/text';
import * as yup from 'yup';

export interface ModalMotivoForm {
  motivo_rechazo: string
  observacion_motivo_rechazo: string
}

export const newPreventaCorporativaSchema = yup.object({
  tipo_enlace: yup.string().required(texto.campo_obligatorio),
  es_demo: yup.boolean().required(texto.campo_obligatorio),
  tipo_plan: yup.string().required(texto.campo_obligatorio),
  tipo_servicio: yup.string().required(texto.campo_obligatorio),
  ancho_banda: yup.string().required(texto.campo_obligatorio),
  comparticion: yup.string().required(texto.campo_obligatorio),
  segmento_red: yup.string().required(texto.campo_obligatorio),
  ip_lan: yup.string().required(texto.campo_obligatorio),
  zona_wifi: yup.boolean().required(texto.campo_obligatorio),
  hotspot: yup.boolean().required(texto.campo_obligatorio),
  router_inalambico: yup.boolean().required(texto.campo_obligatorio),
  vpn: yup.boolean().required(texto.campo_obligatorio),
  espacio_equipos: yup.boolean().required(texto.campo_obligatorio),
  energia_regulada: yup.boolean().required(texto.campo_obligatorio),
  capacidad_para_equipo: yup.boolean().required(texto.campo_obligatorio),

  tipo_puerto_disponible: yup.string().required(texto.campo_obligatorio),
  coordenadas_1: yup.string().required(texto.campo_obligatorio),
  direccion_1: yup.string().required(texto.campo_obligatorio),
  
});



export const newModalMotivoFormaSchema = yup.object({
  motivo_rechazo: yup.string().required('Campo Obligatorio'),
  observacion_motivo_rechazo: yup.string().required('Campo Obligatorio'),
});